module.exports = __webpack_public_path__ + "img/ss_blue-08.78031959.jpg";